/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var Emitter = require('cjs-emitter');

function Intent ( config ) {
    var self = this;

    config = config || {};


    this.action = config.action;

    /**
     *
     * @type {config.data|*}
     */
    this.data = config.data;

    /**
     * Context
     */
    this.context = config.context;


    this.mime = config.mime;


    Emitter.call(this, config);

    if ( config.events ) {
        Object.keys(config.events).forEach(function ( eventName ) {
            self.events[eventName] = [config.events[eventName]];
        });
    }

}


Intent.prototype = Object.create(Emitter.prototype);
Intent.prototype.constructor = Intent;

module.exports = Intent;
